import React from "react"
import { useTranslation } from "react-i18next"
import { IGameUser } from "../../../../../models/colyseus-models/game-user"
import { Role } from "../../../../../types"
import { useAppDispatch, useAppSelector } from "../../../hooks"
import { kick, removeBot } from "../../../stores/NetworkStore"
import { RemoveButton } from "../buttons/remove-button"
import { EloBadge } from "../profile/elo-badge"
import { InlineAvatar } from "../profile/inline-avatar"
import "./preparation-menu-user.css"
import { preference } from "../../../preferences"

export default function PreparationMenuUser(props: {
  key: string
  user: IGameUser
  isOwner: boolean
  ownerId: string
  isDuoMode?: boolean
  isTeammate?: boolean
  isSameTeam?: boolean
  onTeamInvite?: () => void
  onTeamLeave?: () => void
}) {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const user = useAppSelector((state) => state.preparation.user)
  const uid = useAppSelector((state) => state.network.uid)
  const canKick =
    props.isOwner || (user && [Role.MODERATOR, Role.ADMIN].includes(user.role))

  const isSelf = props.user.uid === uid
  const hasTeam = !!props.user.teamId
  const myTeamId = user && (user as any).teamId

  const teamButton = props.isDuoMode && !props.user.isBot && !isSelf ? (
    !hasTeam && (!myTeamId || myTeamId === "") ? (
      <button
        className="bubbly blue team-invite-btn"
        onClick={props.onTeamInvite}
        title={t("invite_to_team")}
        style={{ fontSize: "0.7em", padding: "2px 6px", marginLeft: 4 }}
      >
        {t("invite_to_team")}
      </button>
    ) : null
  ) : null

  const leaveTeamButton = props.isDuoMode && isSelf && hasTeam ? (
    <button
      className="bubbly orange team-leave-btn"
      onClick={props.onTeamLeave}
      title={t("leave_team")}
      style={{ fontSize: "0.7em", padding: "2px 6px", marginLeft: 4 }}
    >
      {t("leave_team")}
    </button>
  ) : null

  const removeButton = props.user.isBot ? (
    <RemoveButton
      onClick={() => {
        dispatch(removeBot(props.user.uid))
      }}
      title={t("remove_bot")}
    />
  ) : canKick && props.user.uid !== uid ? (
    <RemoveButton
      onClick={() => {
        if (confirm(`Kick ${props.user.name} ?`)) {
          dispatch(kick(props.user.uid))
        }
      }}
      title={t("kick_user")}
    />
  ) : null

  const teamBadge = props.isDuoMode && hasTeam ? (
    <span
      className="team-badge"
      style={{
        background: props.isSameTeam ? "#4CAF50" : "#FF9800",
        color: "white",
        borderRadius: 4,
        padding: "1px 4px",
        fontSize: "0.7em",
        marginLeft: 4
      }}
      title={props.isTeammate ? t("teammate") : ""}
    >
      {props.isTeammate ? t("teammate") : t("team")}
    </span>
  ) : null

  return (
    <div
      className={`my-container player my-box preparation-menu-user ${
        props.user.ready ? "ready" : "not-ready"
      }${props.isTeammate ? " teammate" : ""}`}
    >
      <EloBadge elo={props.user?.elo} />
      <InlineAvatar
        avatar={props.user?.avatar}
        name={props.user?.name}
        title={props.user?.title}
        role={props.user?.role}
      />
      {teamBadge}
      {preference("colorblindMode") && props.user.ready && t("ready")}
      {teamButton}
      {leaveTeamButton}
      {removeButton}
    </div>
  )
}
